/**
 * useAdmin composable
 * Provides reactive admin-role state for the logged-in user.
 *
 * The JWT does not carry the role, so we resolve it from the DB via
 * /api/getoneusers (same source the router guard and ProfileDropdown use).
 * State is module-level so the role is fetched once and shared across views.
 */
import { ref } from "vue";
import axios from "axios";

const isAdmin = ref(false);
const isSuperAdmin = ref(false);
let fetched = false;

export async function fetchAdminStatus(force = false) {
  if (fetched && !force) return;
  const userID = localStorage.getItem("userid");
  if (!userID) {
    isAdmin.value = false;
    isSuperAdmin.value = false;
    return;
  }
  try {
    const res = await axios.post("/api/getoneusers", { userID });
    const role = res.data?.[0]?.role;
    // superAdmin has all adminOrg privileges.
    isAdmin.value = role === "adminOrg" || role === "superAdmin";
    isSuperAdmin.value = role === "superAdmin";
    fetched = true;
  } catch {
    isAdmin.value = false;
    isSuperAdmin.value = false;
  }
}

export function useAdmin() {
  return { isAdmin, isSuperAdmin, fetchAdminStatus };
}
